<template>
    <b-container fluid>
        <div v-if="datas.total > 0">
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <div style="display: flex; width: 200px;">
                    <b-button href="#" variant="primary" style="flex: 1;" @click="selectAll">全选</b-button>
                    <b-button href="#" variant="primary" style="flex: 1; margin-left: 16px;"
                        :disabled="checkBooleanArray(selected)" @click="cancelAll">批量驳回</b-button>
                </div>
                <b-pagination v-model="page" :total-rows="datas.total" :per-page="perPage" aria-controls="my-table"
                    @change="getList"></b-pagination>
            </div>
            <b-row style="">
                <b-col md="3" v-for="(item, index) in datas.items" :key="index" style="margin-top: 20px;">
                    <!-- {{ item }} -->
                    <b-card :title="'HKD ' + item.price / 100" img-src="https://picsum.photos/600/300/?image=25"
                        img-alt="Image" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                        <b-card-text>
                            <b-form-checkbox v-model="selected[index]" name="check-button" switch :checked="true">
                            </b-form-checkbox>
                            <div>{{ item.name }}</div>
                            <div>订单号: {{ item.id }}</div>
                            <div>创建时间: {{ formatTimestampCustom(item.create_at) }}</div>
                        </b-card-text>

                        <div style="display: flex;">
                            <b-button href="#" variant="outline-primary" style="flex: 1; margin-right: 6px;"
                                @click="adopt(item, 2)">驳回</b-button>
                            <b-button href="#" variant="primary" style="flex: 1; margin-left: 6px;"
                                @click="adopt(item, 1)">通过</b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-else style="display: flex; justify-content: center; align-items: center; margin-top: 16vh;">
            <div style="display: flex; align-items: center; flex-direction: column; justify-content: center; padding: 30px; border-radius: 20px;">
                <img src="../../assets/images/empty.png" alt="" srcset="" style="width: 300px; height: 300px;">
                <div>
                    当前订单列表为空，请耐心等待...
                </div>
            </div>
        </div>

    </b-container>
</template>
<script>
import { core } from "../../config/pluginInit"
import axiosInstance from '../../services/index'

export default {
    mounted() {
        core.index()

        this.getList()
        this.intervalId = setInterval(() => {
            if (this.checkBooleanArray(this.selected)) {
                this.getList()
            }
        }, 1000)
    },
    beforeDestroy() {
        // 清除定时器
        if (this.intervalId) {
            clearInterval(this.intervalId)
        }
    },
    data() {
        return {
            intervalId: null, // 用于存储定时器的 ID
            selected: [],
            columns: [
                { label: "商户号", key: "id", class: "text-left" },
                { label: "商家昵称", key: "name", class: "text-left" },
                { label: "账号", key: "username", class: "text-left" },
                { label: "注册时间", key: "create_at", class: "text-left" },
                { label: "操作", key: "action", class: "text-center" }
            ],
            datas: {},
            addForm: {},
            editForm: {},
            page: 1,
            perPage: 12,
            qrcode_path: '',
            isBusy: false,
        }
    },
    methods: {
        cancelAll() {
            axiosInstance.post('/order/all_cancel', {
                ids: this.collectSelectedIds(this.datas.items, this.selected),
            }).then((res) => {
                this.selected = []
            }).catch(() => {
                // console.error('创建失败:', error)
            })
        },
        collectSelectedIds(objects, selected) {
            // 检查 selected 数组的长度
            if (selected.length === 0) {
                return '' // 如果 selected 数组为空，返回空字符串
            }

            // 使用 filter 和 map 提取选中的 id 属性值
            const ids = objects
                .filter((_, index) => selected[index] === true) // 过滤出选中的对象
                .map(obj => obj.id) // 提取 id 属性值

            // 使用 join 方法将 id 数组连接成字符串
            return ids.join(',')
        },
        selectAll() {
            const d = this.datas.items
            var f = this.checkBooleanArray(this.selected)

            if (f) {
                for (let i = 0; i < d.length; i++) {
                    this.selected[i] = true
                }
            } else {
                this.selected = []
            }
        },
        checkBooleanArray(arr) {
            // 如果数组长度为0，返回true
            if (arr.length === 0) {
                return true
            }

            // 检查数组内是否有true
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === true) {
                    return false // 如果有true，返回false
                }
            }

            // 如果没有true，返回true
            return true
        },
        adopt(e, a) {
            axiosInstance.post('/order/update', {
                id: e.id,
                status: a,
            }).then((res) => {
            }).catch(() => {
                // console.error('创建失败:', error)
            })
        },
        apiKey(e) {
            this.$bvModal.msgBoxConfirm('APIKEY尤为重要，请不要随意发放，点击"好的"后，APIKEY将复制到您的剪切板。', {
                title: '系统消息',
                okVariant: 'success',
                okTitle: '好的',
                cancelTitle: '取消',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        // 使用Clipboard API复制内容
                        navigator.clipboard.writeText(e.item.key).then(function () {
                            // _this.$bvToast.toast('内容已复制到剪切板', {
                            //     title: "提示",
                            //     variant: 'success',
                            //     solid: true
                            // })
                        }).catch(function () {
                            // console.error('复制失败：', err)
                        })
                    }
                })
        },
        logined() {
            this.getList()
            this.$bvModal.hide('qrcodeShow')
        },
        qrcode(e) {
            this.$bvModal.show('qrcodeShow')

            axiosInstance.get(`/api/robot_api/qrcode?id=${e.item.id}`).then((res) => {
                this.qrcode_path = res.data
            })
        },
        edit(e) {
            this.editForm = Object.assign({}, e.item)

            this.$bvModal.show('editShow')
        },
        remove(e) {
            const _this = this
            this.$bvModal.msgBoxConfirm('确定要执行删除操作吗', {
                title: '请确认',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: '删除',
                cancelTitle: '取消',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.isBusy = true
                        axiosInstance.post('/shop/delete', {
                            id: e.item.id,
                        }).then((res) => {
                            // 获取新数据
                            _this.getList()
                        }).catch(() => {
                            // console.error('创建失败:', error)
                        })
                    }
                })
        },
        getList() {
            this.isBusy = true
            axiosInstance.get(`/order/list?page=${this.page}&perPage=${this.perPage}&status=0`).then((res) => {
                this.datas = res.data
                this.isBusy = false
            })
        },
        formatTimestampCustom(timestamp) {
            const date = new Date(timestamp * 1000)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        }

    },
}
</script>

<style>
.modal {
    background-color: rgba(0, 0, 0, 0.3);
}
</style>
